/* This store is persisted to a cookie automatically.
* JWT tokens need to be stored in cookies for security purposes.
*/

import MutationTypes from '../constants/mutations';
import GetterTypes from '../constants/getters';

const initialState = {
  jwt: null,
};

export default {
  state: initialState,
  getters: {
    [GetterTypes.JWT]: (state) => state.jwt,
    [GetterTypes.IS_SIGNED_IN]: (state) => state.jwt !== null,
  },
  mutations: {
    [MutationTypes.SIGN_IN]: (state, jwt) => {
      state.jwt = jwt;
    },
    [MutationTypes.REFRESH_JWT_TOKEN]: (state, jwt) => {
      state.jwt = jwt;
    },
    [MutationTypes.SIGN_OUT]: (state) => {
      state.jwt = null;
    },
  },
};
